import _ from "lodash";

export const DEFAULT_FEATURED_IMAGE_SETTINGS: any = {
    productImages: [],
    background: {
        backgroundColor: "#D1D5DB",
        backgroundColorCodeKey: "300",
        backgroundColorKey: "gray",
        colorType: "solid"
    },
    noText: true,
    isRepeatImage: false,
    isBackgroundImage: true,
    size: 100,
    fillPatternOffsetXPercentage: 0,
    fillPatternOffsetYPercentage: 0,
    fillPatternRotation: 0,
    fillPatternRepeat: 'no-repeat',
    /*width: 1800,
    height: 1000,*/
    width: 1500,
    height: 1000,
    position: 'left-top',
    containerClass: 'featured-image-stage-container',
    product: {
        fit: "height",
        size: 50,
        fillPatternOffsetXPercentage: 0,
        fillPatternOffsetYPercentage: 0,
        fillPatternRotation: 0,
    }
}

export const FEATURED_IMAGE_FIELD_LIST = [
    /*{attribute: 'size', label: 'Size (%)', type: 'number', readOnly: false, group: 'dimension'},
    {
        attribute: 'fillPatternRotation',
        label: 'Fill Pattern Rotation',
        type: 'number',
        readOnly: false,
        group: 'dimension',
        default: 0
    },*/
    {
        attribute: 'fillPatternOffsetXPercentage',
        label: 'Offset X (%)',
        type: 'number',
        readOnly: false,
        group: 'dimension',
        default: 0
    },
    {
        attribute: 'fillPatternOffsetYPercentage',
        label: 'Offset Y (%)',
        type: 'number',
        readOnly: false,
        group: 'dimension',
        default: 0
    },
];
